'use client';

import { useMemo } from 'react';
import { useBooking } from '../../context/BookingContext';
import { cartHasLowerBoundPricing, cartHasNoPricePricing } from '../../utils/payment-amounts';
import { PaymentTimeline } from './PaymentTimeline';

/**
 * Adaptateur context → props : branche la timeline partagée `PaymentTimeline` sur le
 * `BookingContext` du tunnel classique. Le tunnel VTC rend directement `PaymentTimeline` avec les
 * données du devis.
 */
export function BookingPaymentTimeline(): React.JSX.Element | null {
  const { ctx, labels } = useBooking();
  const preRes = ctx.preReservationData;
  // Montant « plancher » (QUOTE/FROM ou NONE mêlé à des prestas chiffrées) → préfixe « à partir de ».
  const hasLowerBoundPricing = useMemo((): boolean => cartHasLowerBoundPricing(ctx.cartItems), [ctx.cartItems]);
  // Au moins une prestation « aucun prix » (NONE) : le montant sera fixé sur place.
  const hasNoPricePricing = useMemo((): boolean => cartHasNoPricePricing(ctx.cartItems), [ctx.cartItems]);

  if (!preRes) return null;

  return (
    <PaymentTimeline
      paymentType={preRes.payment_type}
      paymentInfos={preRes.payment_infos}
      cancellationDeadlineIso={preRes.cancellation_deadline}
      cancellationDeadlineFormatted={preRes.cancellation_deadline_formatted}
      voucherRefundableOnCancel={preRes.voucher_refundable_on_cancel}
      discountSource={preRes.discount_source}
      hasLowerBoundPricing={hasLowerBoundPricing}
      hasNoPricePricing={hasNoPricePricing}
      labels={labels}
    />
  );
}
